import { Container } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import NavBar from "./NavBar/NavBarContainer";
import SidebarLayout from "./sidebar";
import { useLocation } from "react-router-dom";
import SnackbarNotification from "./SnackbarNotificationStacked";

export default function Layout(props) {
  const location = useLocation();
  const isMobile = useSelector((state) => state.isMobile);
  const themeMode = useSelector((state) => state.themeMode);

  // Derive disableGutters directly from location
  const disableGutters = useMemo(
    () => location.pathname.includes("dashboard/"),
    [location.pathname]
  );

  let width = props.collapsed
    ? isMobile
      ? "100vw"
      : "calc(100vw - 80px)"
    : isMobile
      ? "100vw"
      : "calc(100vw - 280px)";

  if (props.isFullScreen) {
    return props.children;
  }

  if (props.isShare) {
    return props.children;
  }

  return (
    <>
      {isMobile && (
        <NavBar
          handleThemeChange={props.handleThemeChange}
          handleCollapsed={props.handleCollapsed}
        />
      )}
      <div
        style={{
          display: "flex",
          minHeight: isMobile ? "calc(100vh - 64px)" : "100vh",
          width: "100%",
          backgroundColor:
            themeMode && themeMode === "dark" ? "#000" : "#EFEFEF",
        }}
      >
        {isMobile ? null : (
          <SidebarLayout
            collapsed={props.collapsed}
            handleCollapsed={props.handleCollapsed}
            handleThemeChange={props.handleThemeChange}
          />
        )}

        <Container
          component="main"
          maxWidth={disableGutters ? false : "xl"}
          disableGutters={disableGutters}
          sx={{
            p: disableGutters ? 0 : "16px",
            backgroundColor:
              themeMode && themeMode === "dark" ? "#000" : "#EFEFEF",
            maxWidth: width,
          }}
        >
          {props.children}
        </Container>
      </div>
      <SnackbarNotification />
    </>
  );
}
